import { render } from "./App.vue?vue&type=template&id=40aef5ba&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=40aef5ba&scoped=true&lang=css"

import exportComponent from "/home/davidl/projects/cf/page-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40aef5ba"]])

export default __exports__